module.exports = __webpack_public_path__ + "img/icon_mine_chain.a9dffc39.png";